module.exports = __webpack_public_path__ + "img/Flag_of_Bulgaria.e3e19305.svg";